import { render } from "./InsightsModal.vue?vue&type=template&id=df8742f4&scoped=true"
import script from "./InsightsModal.vue?vue&type=script&lang=js"
export * from "./InsightsModal.vue?vue&type=script&lang=js"

import "../../../../reports/css/modal.css?vue&type=style&index=0&id=df8742f4&scoped=true&lang=css"
import "./InsightsModal.vue?vue&type=style&index=1&id=df8742f4&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df8742f4"]])

export default __exports__